// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-underConstruction:hover::-webkit-scrollbar-thumb {
  background-color: var(--color-scrollbar-thumbActive);
  border: 6px solid transparent;
}
.page-underConstruction::-webkit-scrollbar-thumb:hover {
  background-color: var(--color-scrollbar-thumbHover);
}

.page-underConstruction {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  color: var(--color-text);
  background: linear-gradient(132deg, #2c0e12, #1d0d38, #1d1f2c);
  background-size: 400% 400%;
  animation: Gradient 15s ease infinite;
  position: relative;
  overflow: hidden;
  padding: 0;
  margin: 0px;
}
.page-underConstruction .underConstruction-content {
  flex: 1 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.page-underConstruction .underConstruction-content .content-text .text {
  display: flex;
  justify-content: center;
  font-size: 3em;
  font-family: Ubuntu-L, sans-serif;
  text-transform: uppercase;
}
.page-underConstruction .underConstruction-content .content-text .main {
  font-size: 6.8em;
}
@media (min-width: 600px) {
  .page-underConstruction .underConstruction-content .content-text .text {
    font-size: 4em;
  }
  .page-underConstruction .underConstruction-content .content-text .main {
    font-size: 9em;
  }
}
@media (min-width: 900px) {
  .page-underConstruction .underConstruction-content .content-text .text {
    font-size: 5em;
  }
  .page-underConstruction .underConstruction-content .content-text .main {
    font-size: 11.4em;
  }
}
@media (min-width: 1200px) {
  .page-underConstruction .underConstruction-content .content-text .text {
    font-size: 6em;
  }
  .page-underConstruction .underConstruction-content .content-text .main {
    font-size: 13.6em;
  }
}
@media (min-width: 1800px) {
  .page-underConstruction .underConstruction-content .content-text .text {
    font-size: 8em;
  }
  .page-underConstruction .underConstruction-content .content-text .main {
    font-size: 18.2em;
  }
}
.page-underConstruction .underConstruction-content .content-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2em;
  width: 100%;
  flex-direction: column;
  gap: 8px;
}
.page-underConstruction .underConstruction-content .content-bar .bar {
  width: 100%;
  height: 18px;
  background: rgba(238, 238, 238, 0.168627451);
  border-radius: 4px;
}
.page-underConstruction .underConstruction-content .content-bar .bar .bar-inner {
  height: 100%;
  background-color: var(--color-featureColor);
  border-radius: 4px;
}
.page-underConstruction .underConstruction-content .content-bar .bar-info {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 14px;
  font-family: Ubuntu-B, sans-serif;
  opacity: 0.4;
  -webkit-user-select: none;
          user-select: none;
}
.page-underConstruction .underConstruction-footer {
  padding: 3em;
  font-family: Ubuntu-R, sans-serif;
}
.page-underConstruction .cube {
  position: absolute;
  top: 100%;
  left: 100%;
  width: 10px;
  height: 10px;
  border: solid 1px #D7D4E4;
  transform-origin: top left;
  transform: scale(0) rotate(0deg) translate(-50%, -50%);
  animation: cube 12s ease-in forwards infinite;
  opacity: 0.1;
}
.page-underConstruction .cube:nth-child(2) {
  animation-delay: 2s;
  left: 25vw;
  top: 40vh;
}
.page-underConstruction .cube:nth-child(3) {
  animation-delay: 4s;
  left: 75vw;
  top: 50vh;
}
.page-underConstruction .cube:nth-child(4) {
  animation-delay: 6s;
  left: 90vw;
  top: 10vh;
}
.page-underConstruction .cube:nth-child(5) {
  animation-delay: 8s;
  left: 10vw;
  top: 85vh;
}
.page-underConstruction .cube:nth-child(6) {
  animation-delay: 10s;
  left: 50vw;
  top: 10vh;
}
.page-underConstruction .cube:nth-child(7) {
  animation-delay: 0s;
  top: 0;
  left: 0;
}

/* Animate Background*/
@keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes cube {
  from {
    transform: scale(0) rotate(0deg) translate(-50%, -50%);
    opacity: 0.1;
  }
  to {
    transform: scale(20) rotate(960deg) translate(-50%, -50%);
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/scrollbar.scss","webpack://./src/pages/underConstruction/underConstruction.scss","webpack://./src/theme/responsiv.scss"],"names":[],"mappings":"AAwBE;EACE,oDAAA;EACA,6BAAA;ACvBJ;AD0BE;EACE,mDAAA;ACxBJ;;AAHA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,8DAAA;EACA,0BAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;AAMF;AAJE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AAMJ;AAHM;EACE,aAAA;EACA,uBAAA;EACA,cAAA;EACA,iCAAA;EACA,yBAAA;AAKR;AAFM;EACE,gBAAA;AAIR;ACpCI;EDoCI;IACE,cAAA;EAGR;EADM;IACE,cAAA;EAGR;AACF;AC1CI;ED2CI;IACE,cAAA;EAER;EAAM;IACE,iBAAA;EAER;AACF;AChDI;EDkDI;IACE,cAAA;EACR;EACM;IACE,iBAAA;EACR;AACF;ACtDI;EDyDI;IACE,cAAA;EAAR;EAEM;IACE,iBAAA;EAAR;AACF;AAII;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,QAAA;AAFN;AAIM;EACE,WAAA;EACA,YAAA;EACA,4CAAA;EACA,kBAAA;AAFR;AAIQ;EACE,YAAA;EACA,2CAAA;EACA,kBAAA;AAFV;AAMM;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,iCAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;AAJR;AASE;EACE,YAAA;EACA,iCAAA;AAPJ;AAUE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,0BAAA;EACA,sDAAA;EACA,6CAAA;EACA,YAAA;AARJ;AAWE;EACE,mBAAA;EACA,UAAA;EACA,SAAA;AATJ;AAYE;EACE,mBAAA;EACA,UAAA;EACA,SAAA;AAVJ;AAaE;EACE,mBAAA;EACA,UAAA;EACA,SAAA;AAXJ;AAcE;EACE,mBAAA;EACA,UAAA;EACA,SAAA;AAZJ;AAeE;EACE,oBAAA;EACA,UAAA;EACA,SAAA;AAbJ;AAgBE;EACE,mBAAA;EACA,MAAA;EACA,OAAA;AAdJ;;AAsBA,sBAAA;AACA;EACE;IACE,2BAAA;EAnBF;EAqBA;IACE,6BAAA;EAnBF;EAqBA;IACE,2BAAA;EAnBF;AACF;AAsBA;EACE;IACE,sDAAA;IACA,YAAA;EApBF;EAsBA;IACE,yDAAA;IACA,UAAA;EApBF;AACF","sourcesContent":["%scrollbar {\n  /* custom scrollbar */\n  &::-webkit-scrollbar {\n    width: 12px;\n    -webkit-box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n    -moz-box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n    box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--color-scrollbar-thumb);\n    border: 6px solid transparent;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: var(--color-scrollbar-thumbHover);\n  }\n}\n\n%scrollbarHover {\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--color-scrollbar-thumbActive);\n    border: 6px solid transparent;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: var(--color-scrollbar-thumbHover);\n  }\n}","@import '../../theme/scrollbar.scss';\n@import '../../theme/responsiv.scss';\n\n.page-underConstruction {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n  width: 100%;\n  color: var(--color-text);\n  background: linear-gradient(132deg, #2c0e12, #1d0d38, #1d1f2c);\n  background-size: 400% 400%;\n  animation: Gradient 15s ease infinite;\n  position: relative;\n  overflow: hidden;\n  padding:0;\n  margin:0px;\n\n  .underConstruction-content {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n\n    .content-text {\n      .text {\n        display: flex;\n        justify-content: center;\n        font-size: 3em;\n        font-family: Ubuntu-L, sans-serif;\n        text-transform: uppercase;\n      }\n\n      .main {\n        font-size: 6.8em;\n      }\n\n      @include appSize(tablet-portrait-up) {\n        .text {\n          font-size: 4em;\n        }\n        .main {\n          font-size: 9em;\n        }\n      }\n\n      @include appSize(tablet-landscape-up) {\n        .text {\n          font-size: 5em;\n        }\n        .main {\n          font-size: 11.4em;\n        }\n      }\n\n      @include appSize(desktop-up) {\n        .text {\n          font-size: 6em;\n        }\n        .main {\n          font-size: 13.6em;\n        }\n      }\n\n      @include appSize(big-desktop-up) {\n        .text {\n          font-size: 8em;\n        }\n        .main {\n          font-size: 18.2em;\n        }\n      }\n    }\n\n    .content-bar {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-top: 2em;\n      width: 100%;\n      flex-direction: column;\n      gap: 8px;\n\n      .bar {\n        width: 100%;\n        height: 18px;\n        background: #eeeeee2b;\n        border-radius: 4px;\n\n        .bar-inner {\n          height: 100%;\n          background-color: var(--color-featureColor);\n          border-radius: 4px;\n        }\n      }\n\n      .bar-info {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n        font-size: 14px;\n        font-family: Ubuntu-B, sans-serif;\n        opacity: 0.4;\n        user-select: none;\n      }\n    }\n  }\n\n  .underConstruction-footer {\n    padding: 3em;\n    font-family: Ubuntu-R, sans-serif;\n  }\n\n  .cube {\n    position: absolute;\n    top: 100%;\n    left: 100%;\n    width: 10px;\n    height: 10px;\n    border: solid 1px #D7D4E4;\n    transform-origin: top left;\n    transform: scale(0) rotate(0deg) translate(-50%, -50%);\n    animation: cube 12s ease-in forwards infinite;\n    opacity: 0.1;\n  }\n  \n  .cube:nth-child(2) {\n    animation-delay: 2s;\n    left: 25vw;\n    top: 40vh;\n  }\n  \n  .cube:nth-child(3) {\n    animation-delay: 4s;\n    left: 75vw;\n    top: 50vh;\n  }\n  \n  .cube:nth-child(4) {\n    animation-delay: 6s;\n    left: 90vw;\n    top: 10vh;\n  }\n  \n  .cube:nth-child(5) {\n    animation-delay: 8s;\n    left: 10vw;\n    top: 85vh;\n  }\n  \n  .cube:nth-child(6) {\n    animation-delay: 10s;\n    left: 50vw;\n    top: 10vh;\n  }\n\n  .cube:nth-child(7) {\n    animation-delay: 0s;\n    top: 0;\n    left: 0;\n  }\n}\n\n.page-underConstruction:hover {\n  @extend %scrollbarHover;\n}\n  \n/* Animate Background*/\n@keyframes Gradient {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n@keyframes cube {\n  from {\n    transform: scale(0) rotate(0deg) translate(-50%, -50%);\n    opacity: 0.1;\n  }\n  to {\n    transform: scale(20) rotate(960deg) translate(-50%, -50%);\n    opacity: 0;\n  }\n}","@mixin appSize($size) {\n  @if $size == phone-only {\n    @media (max-width: 599px) { @content; }\n  } @else if $size == tablet-portrait-up {\n    @media (min-width: 600px) { @content; }\n  } @else if $size == tablet-landscape-up {\n    @media (min-width: 900px) { @content; }\n  } @else if $size == desktop-up {\n    @media (min-width: 1200px) { @content; }\n  } @else if $size == big-desktop-up {\n    @media (min-width: 1800px) { @content; }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
